import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step8 = ({ setStep, setFormdata, formData, setStep8Status }) => {
  const [error, setError] = useState(""); // State for validation error

  const handleNext = () => {
    if (!formData?.hobbies || formData.hobbies.trim() === "") {
      setError("Please share your hobbies before proceeding."); // Set error if input is empty
    } else {
      setError(""); // Clear error if input is valid
      setStep8Status(true);
      setStep(9); // Proceed to the next step
    }
  };

  return (
    <>
      <div class="top_logo_block">
        <div class="logo">
          <a href="">
            <img src={logo} alt="" />
          </a>
        </div>
      </div>

      <div class="step_body">
        <div class="step_form">
          <div class="form_block box_width_md_one">
            <h1>Any hobbies?</h1>
            <div class="input_fields">
              <input
                type="text"
                placeholder="Please share"
                value={formData?.hobbies}
                onChange={(e) =>
                  setFormdata((prevState) => ({
                    ...prevState, // Keep all other fields the same
                    hobbies: e.target.value, // Update the hobbies field
                  }))
                }
              />
              {error && <p style={{ color: "red" }}>{error}</p>} {/* Display error if present */}
            </div>
          </div>
          <div class="btn_block">
            <a onClick={() => setStep(7)}>
              <img src={prev_arrow} alt="" /> <span>Prev</span>
            </a>
            <a onClick={handleNext} class="nxt_btn">
              <span>Next</span> <img src={next_arrow} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step8;